import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class TicketService {
    
    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {

    }

    consultarOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_orden_to_ticket?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarMotivos(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_motivos_to_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    getUploadURl(type){
      this.url_final = this.backendUrl + "/rmsfe/generar_upload_url?type=" 
      this.url_final = `${this.url_final}${type}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    subirArchivo(url_metodo, file){
      this.url_final = `${url_metodo}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'binary/octet-stream',
           'Anonymous': '' 
        }),
      };
      var fd = new FormData();
      fd.append('file', file, file.name);
      return this.http.put<any>(this.url_final, fd, httpOptions)
      .pipe(map(response => {
        return response;
      }));
    }

    generarTicket(seller, motivo, ord_id, file_name, user_id){
      this.url_final = this.backendUrl + "/rmsfe/nuevo_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { seller, motivo, ord_id, file_name, user_id})
      .pipe(map(response => {
        return response;
      }));
    }

    enviarDevolucion(entries, num_guia, paqueteria, seller, inventario, ord_id, file_name, t_token = null, motivo_seleccionado = null){
      this.url_final = this.backendUrl + "/rmsfe/nueva_devolucion"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, num_guia, paqueteria, seller, inventario, ord_id, file_name, t_token, motivo_seleccionado})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarDireccionOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_dir_ord_to_dev?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    generar_guia_devoluciones_api(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/crear_guia_workflow_devoluciones_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {orden_id: datos_envio.orden_id, paquete_info: datos_envio.paquete_info, paquetes: datos_envio.paquetes, origen: datos_envio.origen, destino: datos_envio.destino})
      .pipe(map(response => {
        return response;
      }));
    }

    consultar_sta_gui(order_id){
      this.url_final = this.backendUrl + "/rmsfe/status_informe_workflow_devoluciones_api?orden_id="
      this.url_final = `${this.url_final}${order_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarStatus(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_status_to_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarInfoTicket(t_token){ 
      this.url_final = this.backendUrl + "/rmsfe/consultar_informacion_ticket?t_token="
      this.url_final = `${this.url_final}${t_token}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    validarOrden(entries, datos_envio, file_name){
      this.url_final = this.backendUrl + "/rmsfe/validar_multicanal"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, datos_envio, file_name})
      .pipe(map(response => {
        return response;
      }));
    }

    enviarOrden(entries, datos_envio, file_name, t_token = null){
      this.url_final = this.backendUrl + "/rmsfe/enviar_multicanal"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, datos_envio, file_name, t_token})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarStatusOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/status_multicanal_api?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarOrdenFF(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_orden?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarEditarOrden(order_id){
      this.url_final = this.backendUrl + "/shopi_orders/consultar_editar_orden_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id})
      .pipe(map(response => {
        return response;
      }));
    }

    setReaundarOrden(order_id){
      this.url_final = this.backendUrl + "/rmsfe/reaundar_orden"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {order_id})
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarOrden(order_id, datos_envio){
      this.url_final = this.backendUrl + "/shopi_orders/actualizar_orden_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id, datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }

    agregarProducto(order_id, cantidad, sku){
      this.url_final = this.backendUrl + "/shopi_orders/agregar_producto_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id, cantidad, sku})
      .pipe(map(response => {
        return response;
      }));
    }

    enviarComentarioTicket(seller, comentarioTicket, ord_id, file_name, user_id, ticket_id){
      this.url_final = this.backendUrl + "/rmsfe/nuevo_comentario_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { seller, comentarioTicket, ord_id, file_name, user_id, ticket_id})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarHistorialComentarios(ticket_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_historial_comen_to_ticket?ticket_id="
      this.url_final = `${this.url_final}${ticket_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarEstadoMensajes(ticket_id){
      this.url_final = this.backendUrl + "/rmsfe/cambiar_estado_mensajes_to_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {ticket_id})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarTotalNotificaciones(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_total_notificaciones"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarEstadoTicket(ticket_id, id_estado){
      this.url_final = this.backendUrl + "/rmsfe/cambiar_estado_to_ticket"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {ticket_id, id_estado})
      .pipe(map(response => {
        return response;
      }));
    }
    
}